export default {
  diagnosis: {
    /*
    anyDocumentaion: {
      anyValues: {
        issues: [
          {
            id: "I-MH-DIAG-1000",
            domain: "DPMH",
          },
        ],
      },
      triggerValue: true,
    }, */
    activeTreatment: {
      issues: [
        {
          id: 'I-MH-DIAG-1300',
          domain: 'DTP',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'no'
    },
    treatmentOptions: {
      issues: [
        {
          id: 'I-MH-DIAG-1400',
          domain: 'DKC',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'no'
    },
    understandTreatment: {
      issues: [
        {
          id: 'I-MH-DIAG-1500',
          domain: 'DKC',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'no'
    },
    complianceTreatment: {
      issues: [
        {
          id: 'I-MH-DIAG-1600',
          domain: 'DTP',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'no'
    },
    secondOpinion: {
      issues: [
        {
          id: 'I-MH-DIAG-1800',
          domain: 'DPAE',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'yes'
    },
    clinicalTrialInterest: {
      issues: [
        {
          id: 'I-MH-DIAG-1900',
          domain: 'DKC',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'yes'
    },
    clinicalTrialAccess: {
      issues: [
        {
          id: 'I-MH-DIAG-2000',
          domain: 'DPAE',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'no'
    },
    clinicalTrialParticipation: {
      issues: [
        {
          id: 'I-MH-DIAG-2100',
          domain: 'DKC',
          isDynamic: true,
          dynamicParameters: { diagnosis: 'name' }
        }
      ],
      triggerValue: 'yes'
    }
  },
  events: {
    admissions: {
      // facility: {
      //   unDocumented: {
      //     issues: [
      //       {
      //         id: 'I-MH-ADMT-4800',
      //         domain: 'DHEDV'
      //       }
      //     ]
      //   }
      // },
      // physician: {
      //   unDocumented: {
      //     issues: [
      //       {
      //         id: 'I-MH-ADMT-4900',
      //         domain: 'DHEDV',
      //         isDynamic: true,
      //         dynamicParameters: { organization: 'facility' }
      //       }
      //     ]
      //   }
      // },
      status: {
        issues: [
          {
            id: 'I-MH-ADMT-5100',
            domain: 'DHEDV',
            isDynamic: true,
            dynamicParameters: { organization: 'facility' }
          }
        ],
        triggerValue: true
      }
      // reason: {
      //   unDocumented: {
      //     issues: [
      //       {
      //         id: 'I-MH-ADMT-4700',
      //         domain: 'DHEDV',
      //         isDynamic: true,
      //         dynamicParameters: { organization: 'facility' }
      //       }
      //     ]
      //   }
      // },
      //   type: {
      //     unDocumented: {
      //       issues: [
      //         {
      //           id: 'I-MH-ADMT-5200',
      //           domain: 'DHEDV',
      //           isDynamic: true,
      //           dynamicParameters: { organization: 'facility' }
      //         }
      //       ]
      //     }
      //   }
    },
    procedures: {
      // name: {
      //   unDocumented: {
      //     issues: [
      //       {
      //         id: "I-MH-PROC-2600",
      //         domain: "DHEDV",
      //         isDynamic: true,
      //         dynamicParameters: { procedureName: "name" }
      //       }
      //     ]
      //   }
      // }
      // physician: {
      //   unDocumented: {
      //     issues: [
      //       {
      //         id: 'I-MH-PROC-2700',
      //         domain: 'DHEDV',
      //         isDynamic: true,
      //         dynamicParameters: { procedureName: 'name' }
      //       }
      //     ]
      //   }
      // },
      // type: {
      //   unDocumented: {
      //     issues: [
      //       {
      //         id: 'I-MH-PROC-2800',
      //         domain: 'DHEDV',
      //         isDynamic: true,
      //         dynamicParameters: { procedureName: 'name' }
      //       }
      //     ]
      //   }
      // }
    }
  }
}
